module.exports = __webpack_public_path__ + "static/media/goodblockio.cf4f776e.jpg";